<script lang="ts" setup>
import { ErrorLayout } from '@app/panel/Layouts';

defineProps<{
  status: string | number;
  requestId?: string;
}>();
</script>

<template>
  <ErrorLayout
    :status="status"
    title="There's no page at this address"
  >
    <p>
      Check the URL and try again, or use the search bar to find what you need.
    </p>
  </ErrorLayout>
</template>
